module.exports = __webpack_public_path__ + "img/picture_kcsp.5ad73f99.png";